/* unplugin-vue-components disabled */import { render } from "./show.vue?vue&type=template&id=1c076d70&scoped=true"
import script from "./show.vue?vue&type=script&lang=js"
export * from "./show.vue?vue&type=script&lang=js"

import "./show.vue?vue&type=style&index=0&id=1c076d70&lang=less&scoped=true"

import exportComponent from "D:\\work\\2025\\yddh\\web\\xsspm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c076d70"]])

export default __exports__